// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","container":"G9c0fb8","content":"G5bc6c7 G481d88","modalList":"G57b1b1"};